// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608210610/js/" + chunkId + "." + {"44":"1d594795","225":"5c40ac86","481":"c5f3d59a","486":"7dcd0958","770":"ce47ef8c"}[chunkId] + ".0.5166701575270792.chunk.js";
};